/**
 * The minerals map feature (M8 plan MC-a7b, RD7(a); reach mode only): registers the galaxy map's "Minerals" layer
 * (`overlay.ts`) through `registerMapOverlay`, reading `ctx.reach` (its galaxy and live state) on each call. The map
 * side panel's own signature and grade lines are `maps/view/panel.ts systemDetails`. No `UiActions` or `CareerPort`
 * member, no save change.
 */
import { FEATURE_ORDER, type GameContext, type GameFeature } from '../../app/feature'
import { registerMapOverlay } from '../../maps/model/overlays'
import { createMineralsLayer } from './overlay'

/** After the maps feature (750) and the route finder (751). */
const ORDER = FEATURE_ORDER.maps + 2

export interface MineralsMapFeature extends GameFeature {
  dispose(): void
}

export function createMineralsMapFeature(): MineralsMapFeature {
  let off: (() => void) | null = null
  return {
    name: 'mineralsMap',
    order: ORDER,
    init(ctx: GameContext): void {
      const reach = ctx.reach
      if (reach === null) return
      off?.()
      off = registerMapOverlay(createMineralsLayer(() => ({ galaxy: reach.galaxy, state: reach.state })))
    },
    dispose(): void {
      off?.()
      off = null
    },
  }
}

export default createMineralsMapFeature()
